import { history } from '../History';

const hist = history();

(globalThis as any).histore = history();

export function useHistory() {
  return hist;
}
